import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Assets
import arrowIcon from "../../assets/previous_icon.png";
import editIcon from "../../assets/edit_icon.png";

// Utils
import useLanguage from "../../utils/useLanguage";

// Components
import InformationBox from "../../components/InformationBox";
import CustomButton from "../../components/CustomButton";
import CopyButton from "../../components/CopyButton";

const RulerTable = ({ data, onEditRuler }) => {
  const { currentDirection } = useLanguage();
  const { t } = useTranslation("general");

  // STATES
  const [collapsed, setCollapsed] = useState({});

  const toggleCollapse = (fabricCode) => {
    setCollapsed((prev) => ({
      ...prev,
      [fabricCode]: !prev[fabricCode],
    }));
  };

  // SIDE EFFECTS
  useEffect(() => {
    const initialCollapsed = {};
    data.forEach((fabric) => {
      initialCollapsed[fabric.code] = true;
    });
    setCollapsed(initialCollapsed);
  }, [data]);

  return (
    <div
      className="c-fabric-table o-column o-column--gap-size_400 u-margin u-margin--bottom_700"
      dir={currentDirection}
    >
      {data.length === 0 ? (
        <InformationBox>{t("noRulersFound")}</InformationBox>
      ) : null}
      {data.map((fabric) => (
        <div className="" key={fabric.code}>
          <div className="c-fabric-block">
            <div
              className="c-fabric-header o-row--horizontal-align_space-between"
              onClick={() => toggleCollapse(fabric.code)}
            >
              <div>
                <span className="c-collapse-icon" style={{ cursor: "pointer" }}>
                  <img
                    src={arrowIcon}
                    alt="Collapse"
                    style={{
                      width: 16,
                      transform: collapsed[fabric.code]
                        ? "rotate(0deg)"
                        : "rotate(-90deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </span>

                <span className="c-fabric-code">
                  {t("code")}: {fabric.code}
                </span>
              </div>
              <CustomButton
                title={t("edit")}
                variant="blank"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditRuler(fabric);
                }}
                icon={editIcon}
                iconSize={18}
              />
            </div>

            {!collapsed[fabric.code] && (
              <table className="c-fabric-inner-table">
                <thead>
                  <tr>
                    <th>{t("colorCode")}</th>
                    <th>{t("colorName")}</th>
                    <th>{t("quantity")}</th>
                    <th>{t("averageCost")}</th>
                  </tr>
                </thead>
                <tbody>
                  {fabric.colors.map((color) => (
                    <tr key={color.colorCode}>
                      <td className="o-row o-row--horizontal-align_center o-row--vertical-align_center o-row--gap-size_400">
                        <CopyButton text={color?.colorCode} />
                        <Link to={color?.to}>{color?.colorCode}</Link>
                      </td>
                      <td>{color?.colorName}</td>
                      <td>
                        {color.availableStock} {t("meter")}
                      </td>
                      <td>
                        {color?.averageCost?.toFixed(2) || (0).toFixed(2)}{" "}
                        {t(color.currency || "usd")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
export default RulerTable;
